
import { IErrorStore } from "../../../error/types";

import type {
  TDirectSalesCatDetailsViewState,
  TFieldKey,
  TDirectSalesViewState,
} from "@./suf-store";
import type { IBaseStoreState } from "../../shared/baseStore.types";

import type { DirectSalesFlowSlug } from "./constants";

export enum TargetUser {
  CUSTOMER = "CUSTOMER",
  BRAND_AMBASSADOR = "BRAND_AMBASSADOR",
}

export interface IDirectSalesSignupFlowStore extends IBaseStoreState {
  viewState: TDirectSalesViewState;
  updateViewState(
    view: string,
    params: Partial<TDirectSalesViewState[keyof TDirectSalesViewState]> | Partial<TDirectSalesCatDetailsViewState>,
    catId?: string,
  ): void;
  sufQuizVersion: number;
  /** Soft reset the store to the initial user state. Preserves the card reader id and discount. */
  clearUserData(): void;
  /** Hard reset the store to the initial user state. Resets the card reader id and discount. */
  resetSignupFlow(): void;
  cardReaderId: string;
  setCardReaderId(id: string): void;
  /** Determines which payment options should be shown to the user. */
  targetUser: TargetUser
  /** Sets the target user to determine which payment options should be shown to the user. */
  setTargetUser(target: TargetUser): void;
}

export type IDirectSalesSignupFlowErrorStore = IErrorStore<TFieldKey, DirectSalesFlowSlug>;
